import React from "react"
import SaHardware from './svg/sa-hardware'
import SaBackHardware from './svg/sa-back-hardware'
import SaWebbing from './svg/sa-webbing'
import SaBackWebbing from './svg/sa-back-webbing'
import SaLabel from './svg/sa-label'
import SaMainA from './svg/sa-main_fabric_front_a'
import SaMainB from './svg/sa-main_fabric_front_b'
import SaMainC from './svg/sa-main_fabric_front_c'
import SaBackMainA from './svg/sa-back-main_fabric_front_a'
import SaEdgeBinding from './svg/sa-edge_binding'
import SaBackEdgeBinding from './svg/sa-back-edge_binding'
import SaZipperPuller from './svg/sa-zipper_puller'
import SaBackZipperPuller from './svg/sa-back-zipper_puller'
import SaZipper from './svg/sa-zipper'
import SaBackZipper from './svg/sa-back-zipper'
import SaMainBack from './svg/sa-back-fabric_back'

export const SketchSaFront = ({ size, getColor, getPattern, getLineColor, showSoftZipper, showPointPattern, currrentComposition }) => (
  <svg id="front" className="front-sa" viewBox="-115 0 480 480" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs>
      <linearGradient x1="-.122%" y1="46.317%" x2="100.045%" y2="46.317%" id="e">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="-.001%" y1="50.013%" x2="100.339%" y2="50.013%" id="f">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="18.17%" y1="51.345%" x2="84.62%" y2="51.345%" id="g">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="-.118%" y1="52.276%" x2="99.605%" y2="52.276%" id="h">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="2%" y1="49.007%" x2="99.432%" y2="49.007%" id="i">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1=".709%" y1="50.878%" x2="100.343%" y2="50.878%" id="j">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="3.611%" y1="50.866%" x2="99.984%" y2="50.866%" id="k">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1=".11%" y1="50.461%" x2="100.11%" y2="50.461%" id="l">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1=".289%" y1="50.624%" x2="100.231%" y2="50.624%" id="m">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1=".367%" y1="50.943%" x2="100.302%" y2="50.943%" id="n">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="1.573%" y1="47.389%" x2="100.393%" y2="47.389%" id="o">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="-.35%" y1="48.336%" x2="98.835%" y2="48.336%" id="p">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="44.595%" y1="47.687%" x2="57.185%" y2="52.113%" id="q">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="7.5%" y1="43.215%" x2="94.923%" y2="55.421%" id="r">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="7.5%" y1="47.864%" x2="104.923%" y2="51.928%" id="s">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="27.926%" y1="43.082%" x2="80.663%" y2="52.287%" id="t">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="-1.093%" y1="49.503%" x2="99.6%" y2="49.503%" id="u">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="13.571%" y1="41.778%" x2="85.966%" y2="53.067%" id="v">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="18.192%" y1="43.581%" x2="94.994%" y2="54.227%" id="w">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="19.726%" y1="39.754%" x2="96.533%" y2="50.4%" id="x">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1=".11%" y1="50.492%" x2="100.11%" y2="50.492%" id="A">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="-.966%" y1="50.167%" x2="97.675%" y2="50.167%" id="B">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="-.319%" y1="49.873%" x2="100.228%" y2="49.873%" id="C">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <pattern id="garden" patternUnits="userSpaceOnUse" width="254" height="544">
        <image xlinkHref={getPattern('garden')} x="-5" y="200" width="250" height="344"/>
      </pattern>
      <pattern id="rust" patternUnits="userSpaceOnUse" width="254" height="544">
        <image xlinkHref={getPattern('rust')} x="-5" y="200" width="254" height="344"/>
      </pattern>
      <pattern id="green" patternUnits="userSpaceOnUse" width="254" height="544">
        <image xlinkHref={getPattern('green')} x="-5" y="200" width="254" height="344"/>
      </pattern>
      <pattern id="beige" patternUnits="userSpaceOnUse" width="254" height="544">
        <image xlinkHref={getPattern('beige')} x="-5" y="200" width="254" height="344"/>
      </pattern>
      <pattern id="grey" patternUnits="userSpaceOnUse" width="254" height="544">
        <image xlinkHref={getPattern('grey')} x="-5" y="200" width="254" height="344"/>
      </pattern>
      <pattern id="violet" patternUnits="userSpaceOnUse" width="254" height="544">
        <image xlinkHref={getPattern('violet')} x="-5" y="200" width="254" height="344"/>
      </pattern>
      <pattern id="black" patternUnits="userSpaceOnUse" width="254" height="544">
        <image xlinkHref={getPattern('black')} x="-5" y="200" width="254" height="344"/>
      </pattern>
    </defs>
    <g fill="none" fillRule="evenodd">
      <SaHardware />
      <SaWebbing
        fillColor='#000'
        strokeColor='#fff'
      />
      <SaMainB
        fillColor={getColor(currrentComposition.case[1].color)}
        strokeColor={getLineColor(currrentComposition.case[1].color)}
      />
      <SaEdgeBinding
        fillColor={getColor(currrentComposition.case[3].color)}
        strokeColor={getLineColor(currrentComposition.case[3].color)}
      />
      <SaMainC
        fillColor={getColor(currrentComposition.case[2].color)}
        strokeColor={getLineColor(currrentComposition.case[2].color)}
      />
      <SaLabel color={currrentComposition.case[7].color} />
      <SaZipper
        fillColor={getColor(currrentComposition.case[5].color)}
        strokeColor={getLineColor(currrentComposition.case[5].color, currrentComposition.case[5].comp)}
      />
      <SaZipperPuller
        showSoft={showSoftZipper(currrentComposition.case[6].color)}
        showPattern={showPointPattern(currrentComposition.case[6].color)}
        fillColor={getColor(currrentComposition.case[6].color, currrentComposition.case[6].comp)}
        strokeColor={getLineColor(currrentComposition.case[6].color)}
      />
      <SaMainA
        fillColor={getColor(currrentComposition.case[0].color)}
        strokeColor={getLineColor(currrentComposition.case[0].color)}
      />
    </g>
  </svg>
)

export const SketchSaBack = ({ size, getColor, getLineColor, showSoftZipper, showPointPattern, currrentComposition, getPattern }) => (
  <svg id="back" className="back-sa" viewBox="-115 0 490 490" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs>
      <linearGradient x1="-.122%" y1="46.317%" x2="100.045%" y2="46.317%" id="ee">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="-.001%" y1="50.013%" x2="100.339%" y2="50.013%" id="ff">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="18.17%" y1="51.345%" x2="84.62%" y2="51.345%" id="gg">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="-.118%" y1="52.276%" x2="99.605%" y2="52.276%" id="hh">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="2%" y1="49.007%" x2="99.432%" y2="49.007%" id="ii">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1=".709%" y1="50.878%" x2="100.343%" y2="50.878%" id="jj">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1="3.611%" y1="50.866%" x2="99.984%" y2="50.866%" id="kk">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1=".11%" y1="50.461%" x2="100.11%" y2="50.461%" id="ll">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1=".289%" y1="50.624%" x2="100.231%" y2="50.624%" id="mm">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <linearGradient x1=".11%" y1="50.492%" x2="100.11%" y2="50.492%" id="pp">
        <stop stopColor="#FFF" offset="0%"/>
        <stop offset="100%"/>
      </linearGradient>
      <pattern id="garden" patternUnits="userSpaceOnUse" width="254" height="544">
        <image xlinkHref={getPattern('garden')} x="-5" y="200" width="250" height="344"/>
      </pattern>
      <pattern id="rust" patternUnits="userSpaceOnUse" width="254" height="544">
        <image xlinkHref={getPattern('rust')} x="-5" y="200" width="254" height="344"/>
      </pattern>
      <pattern id="green" patternUnits="userSpaceOnUse" width="254" height="544">
        <image xlinkHref={getPattern('green')} x="-5" y="200" width="254" height="344"/>
      </pattern>
      <pattern id="beige" patternUnits="userSpaceOnUse" width="254" height="544">
        <image xlinkHref={getPattern('beige')} x="-5" y="200" width="254" height="344"/>
      </pattern>
      <pattern id="grey" patternUnits="userSpaceOnUse" width="254" height="544">
        <image xlinkHref={getPattern('grey')} x="-5" y="200" width="254" height="344"/>
      </pattern>
      <pattern id="violet" patternUnits="userSpaceOnUse" width="254" height="544">
        <image xlinkHref={getPattern('violet')} x="-5" y="200" width="254" height="344"/>
      </pattern>
      <pattern id="black" patternUnits="userSpaceOnUse" width="254" height="544">
        <image xlinkHref={getPattern('black')} x="-5" y="200" width="254" height="344"/>
      </pattern>
    </defs>
    <g fill="none" fillRule="evenodd">
      <SaBackZipper
        fillColor={getColor(currrentComposition.case[5].color)}
        strokeColor={getLineColor(currrentComposition.case[5].color, currrentComposition.case[5].comp)}
      />
      <SaMainBack
        fillColor={getColor(currrentComposition.case[4].color)}
        strokeColor={getLineColor(currrentComposition.case[4].color)}
      />
      <SaBackMainA
        fillColor={getColor(currrentComposition.case[0].color)}
        strokeColor={getLineColor(currrentComposition.case[0].color)}
      />
      <SaBackEdgeBinding
        fillColor={getColor(currrentComposition.case[3].color)}
        strokeColor={getLineColor(currrentComposition.case[3].color)}
      />
      <SaBackZipperPuller
        showSoft={showSoftZipper(currrentComposition.case[6].color)}
        showPattern={showPointPattern(currrentComposition.case[6].color)}
        fillColor={getColor(currrentComposition.case[6].color, currrentComposition.case[6].comp)}
        strokeColor={getLineColor(currrentComposition.case[6].color)}
      />
      <SaBackHardware />
      <SaBackWebbing
        fillColor='#000'
        strokeColor='#fff'
      />
    </g>
  </svg>
)